import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '../../Api/ChessRestClient';

export interface LichessStudyMeta {
  id: string;
  name: string;
  // Lichess's study listing doesn't always expose visibility — null means
  // unknown (the backend resolves it during the actual import).
  visibility: 'public' | 'private' | 'unlisted' | null;
  updated_at: string | null;
  already_imported: boolean;
  // Imported before, but updated on Lichess since the last sync.
  needs_update: boolean;
}

export interface ListLichessStudiesMetaResponse {
  success: boolean;
  studies: LichessStudyMeta[];
  error?: string;
}

export default function useListLichessStudiesMeta(
  handleOnSuccess?: (data: ListLichessStudiesMetaResponse) => void,
  handleOnError?: (error: any) => void,
) {
  return useMutation<ListLichessStudiesMetaResponse, Error, void>(
    async () => {
      const response = await ChessRestClient.get(
        '/learning/study_games/list_lichess_studies_meta/',
      );
      return response.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess) handleOnSuccess(data);
      },
      onError: error => {
        if (handleOnError) handleOnError(error);
      },
    },
  );
}
